require('backbone-validation');

var LAT_MIN = -90;
var LAT_MAX = 90;
var LONG_MIN = -180;
var LONG_MAX = 180;

_.extend(Backbone.Validation.validators, {
    longitude: function (value, attr, validatorVal, model, computed) {
        return this.range(value, attr, [LONG_MIN, LONG_MAX]);
    },
    latitude: function (value, attr, validatorVal, model, computed) {
        return this.range(value, attr, [LAT_MIN, LAT_MAX]);
    }
});

module.exports = {
    getIsRequiredMessageForFieldName: function (fieldName) {
        return _.template('<%= fieldName %> is required')({
            fieldName: fieldName
        });
    }
};



/** WEBPACK FOOTER **
 ** ./assets/js/entities/validation.js
 **/